// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__4Adfx","content":"RecentSearches_content__11O3W"};